var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-footer-menu text-center"},[_c('router-link',{staticClass:"ad1-button el-icon-plus",attrs:{"tag":"button","circle":"","to":{ name: _vm.isUser ? 'CreateAd' : 'Welcome' }}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09818fbc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/FooterMenu.vue
// module id = 1234
// module chunks = 1 3 7